import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SocialTiktok = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="M9.335 9.632C6.355 9.862 4 12.316 4 15.304c0 1.496.592 2.858 1.56 3.878A5.85 5.85 0 0 0 9.805 21c3.2 0 5.806-2.553 5.806-5.696v-6.29A7.6 7.6 0 0 0 20 10.397V7.305a4.4 4.4 0 0 1-.92-.097 4.4 4.4 0 0 1-2.39-1.387A4.23 4.23 0 0 1 15.612 3h-.843m1.921 2.821-.049-.032M7.66 16.817a2.54 2.54 0 0 1-.502-1.517c0-1.434 1.188-2.6 2.65-2.6.272 0 .536.046.783.121v-3.16a6 6 0 0 0-.784-.054c-.02 0-.1.005-.188.01m0 0c-.12.007-.256.015-.283.015m.283-.015.048-.001m-.048 0a6 6 0 0 0-.283.016M14.765 3h-2.31l-.004 12.4c-.05 1.387-1.218 2.503-2.645 2.503-.886 0-1.665-.43-2.151-1.082"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SocialTiktok) as SvgIcon;
export { ForwardRef as ReactComponent };
